import React, { useContext } from 'react';
import {
 Col, Container, Row, Modal, 
} from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import DefaultTabsBorderedBottom from './component/DefaultTabsBorderedBottom';
import AddTrip from './component/Booking/components/AddTrip';
import { BookingContext } from '../../../context/BookingContext';
import { AuthContext } from '../../../context/AuthContext';
import BookingForm from './component/Booking/components/BookingForm';




const Meal = () => {
  const {
    MealBookingData, setMealBookingData, showAddTripModal, setShowAddTripModal, paxs,
   } = useContext(BookingContext);
   const { apiGlobal, userid } = useContext(AuthContext);


   const hidetripmodalHandler = () => {
    setMealBookingData(prevState => ({
      ...prevState,
      showMealBookingModal: true,
    }));
    setShowAddTripModal(false);
  };

   const handletripAdd = async (values) => {
      console.log(JSON.stringify(values, null, 2));
      const utcStartDate = values.startDate;
      const utcEndDate = values.endDate;
  
         // Convert to IST
         const startDate = new Date(utcStartDate);
         const endDate = new Date(utcEndDate);

         if (startDate >= endDate) {
          toast.error('Start date must be earlier than end date');
          return; // Or any other action you'd like to perform
        }
     
         // IST offset is +5:30
        const istOffset = 5.5 * 60 * 60 * 1000;
        const startDateIST = new Date(startDate.getTime() + istOffset);
        const endDateIST = new Date(endDate.getTime() + istOffset); 
        
        // Format the dates (DD-MM-YYYY)
        const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1)
         .padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
     
     
     const formattedStartDate = formatDate(startDateIST);
     const formattedEndDate = formatDate(endDateIST);
  
     const formattedValues = {
      pax_details: paxs,
  };
  
  const formattedPaxDetails = JSON.stringify(formattedValues);
  
  
    
  
      const formData = new FormData();
      formData.append('user_id', userid);
      formData.append('agent_id', values.selectAgent.value);
      formData.append('name', values.tripname);
      formData.append('start_date', formattedStartDate);
      formData.append('end_date', formattedEndDate);
      formData.append('trip_type', values.triptype);
      formData.append('pax_details', formattedPaxDetails);
      
        
    try {
      // Send POST request with form data
      const response = await fetch(`${apiGlobal}/trip_add.php`, {
        method: 'POST',
        // headers: {
        //   'Content-Type': 'application/json',
        // },
        body: formData, 
      });
    
      if (response.ok) {
        const data = await response.json(); // Parsing the response JSON
        if (data.status && data.message === 'Success') {
          toast.success('Trip added successfully...');
          hidetripmodalHandler();
        }
      } else {
        // Handle non-200 responses
        console.error('Error:', response.statusText);
        toast.error('Something went wrong while adding paxs');
      }
    } catch (error) {
      // Catch any network or other errors
      console.error('Error during fetch:', error);
    }
    };


  return (
    <div>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
      marginBottom: '5px',
    }}
      >
        <Typography sx={{ color: 'text.primary' }}>Admin</Typography>
        <Typography sx={{ color: 'text.primary' }}>Meal</Typography>
        <Typography sx={{ color: 'text.primary' }}>Search</Typography>
      </Breadcrumbs>
      <Row>
        <DefaultTabsBorderedBottom />
      </Row>
      {/* placed add trip here beacause of re-render issue */}
      {/* all stated placed in BookingContext */}
      <Modal
        show={showAddTripModal}
        onHide={hidetripmodalHandler}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Trip</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddTrip onSubmit={handletripAdd} />
        </Modal.Body>
      </Modal>
      <Modal
        show={MealBookingData.showMealBookingModal === true}
        onHide={() => setMealBookingData(prevState => ({
         ...prevState,
         showMealBookingModal: false,
       }))}     
        centered
        fullscreen
        backdrop="static" // Prevent clicking outside the modal to close it
        keyboard={false} 
        style={{
                  display: 'none',
                }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Make Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BookingForm 
            mealName={MealBookingData?.mealname}
            resName={MealBookingData?.restaurantname}
            price={MealBookingData?.finalprice}
            id={MealBookingData?.id}
            mealOffereds={MealBookingData?.mealOffereds}
            locations={MealBookingData?.locations}
            format={MealBookingData?.format}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default Meal;
